// Mirrors RuntimeCatalogRepository on iOS/Android. Normalize the runtime wire
// shape once, preserving provider identities and integer odds/line values.
export function runtimeMarketType(name) {
  const text = name.toLowerCase()
  if (text.includes('moneyline') || text === 'match winner') return 'MONEYLINE'
  if (text.includes('spread') || text.includes('handicap')) return 'SPREAD'
  if (text.includes('total')) return 'TOTAL'
  return 'OFFERING'
}
export function normalizeRuntimeScore(score) {
  if (!score) return null
  const homeScore = score.home_score ?? score.home ?? null
  const awayScore = score.away_score ?? score.away ?? null
  return {
    ...score,
    home_score: homeScore != null ? String(homeScore) : '',
    away_score: awayScore != null ? String(awayScore) : '',
    match_occurrence: score.match_occurrence ?? score.score_info ?? score.scoreInfo ?? null,
  }
}

export function normalizeRuntimeClock(clock) {
  if (!clock) return null
  return {
    ...clock,
    period: clock.period ?? '',
    minute: Number(clock.minute ?? 0),
    second: Number(clock.second ?? 0),
  }
}

export function normalizeRuntimePreviewCatalog(value) {
  if (!Array.isArray(value?.events)) throw new Error('The runtime returned an invalid catalog.')
  return { ...value, freshness: ['current', 'replicated'].includes(value.freshness) ? value.freshness : 'stale', events: value.events.map((event) => {
    if (!event.id || !event.name || !Array.isArray(event.markets)) throw new Error('The runtime returned an invalid event.')
    return {
      ...event,
      live: Boolean(event.live || event.source_status === 'STARTED'),
      score: normalizeRuntimeScore(event.score),
      clock: normalizeRuntimeClock(event.clock),
      league: event.group,
      status: event.source_status || event.status || 'OPEN',
      markets: event.markets.map((market) => ({
        ...market,
        label: market.name,
        type: market.type || runtimeMarketType(market.name),
        outcomes: market.outcomes.map((outcome) => ({
          ...outcome,
          label: outcome.name,
          odds: outcome.odds_millis ?? null,
          line: outcome.line_millis ?? null,
        })),
      })),
    }
  }) }
}

// React Query retains the last successful response after a failed refresh.
export function runtimePreviewCatalogState({ data, isError }) {
  return { ...(data || { events: [] }), freshness: isError ? 'stale' : data?.freshness ?? 'stale' }
}
